/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Lightning': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M144.528 75.738c0 38.123-30.906 69.03-69.03 69.03s-69.03-30.907-69.03-69.03c0-38.125 30.906-69.029 69.03-69.029s69.03 30.904 69.03 69.03" _fill="#FAB536"/><path pid="1" d="M88.029 23.723c-1.696 4.557-3.886 10.232-6.565 17.02a2346.542 2346.542 0 00-9.248 23.859c5.002-1.25 11.3-2.725 18.896-4.424a6366.213 6366.213 0 0126.537-6.164A6012.475 6012.475 0 0196.07 85.11a25603.28 25603.28 0 01-30.156 43.556c1.879-5.896 4.243-13.22 7.105-21.978 2.86-8.758 6.164-19.031 9.916-30.828-5.541 1.609-12.418 3.533-20.638 5.765-8.223 2.233-17.873 4.869-28.952 7.909 6.076-7.327 13.67-16.49 22.785-27.477a11955.506 11955.506 0 0031.898-38.334" _fill="#000"/></g>'
  }
})
